import { PortalTelemetryScreen } from '../telemetry/portalTelemetryScreens';
import { portalAction, portalScreenContext } from '../telemetry/portalTelemetry';
import { usePortalScreen } from '../telemetry/usePortalTelemetry';
import { Button, Grid, Typography } from "@mui/material";
import { safePaymentRetryUrl } from '../utils/paymentReturn';

interface Props {
    retryUrl: string;
    onRetry?: () => void;
}

export default function PaymentUnsuccessful({ retryUrl, onRetry }: Props) {
    const queryParams = new URLSearchParams(window.location.search);
    const responseCode = queryParams.get("Rc");
    const safeRetryUrl = safePaymentRetryUrl(retryUrl, window.location.origin);

    usePortalScreen(portalScreenContext(PortalTelemetryScreen.PaymentUnsuccessful), undefined, true);

    return (
        <>
            {responseCode !== "C" &&
                <Grid size={{ xs: 12 }}>
                    <Typography variant='h4'>Payment unsuccessful</Typography>
                </Grid>
            }

            {responseCode === "C" &&
                <Grid size={{ xs: 12 }}>
                    <Typography variant='h4'>Payment cancelled</Typography>
                </Grid>
            }

            <Grid size={{ xs: 12 }}>
                <Typography variant='subtitle1'>
                    Your payment was not completed. Please use the button below to return
                    to the payments summary screen and try again.
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }} sx={{ marginBottom: '2%' }}>
                {safeRetryUrl && <Button variant="contained" color="primary"
                    onClick={portalAction(portalScreenContext(PortalTelemetryScreen.PaymentUnsuccessful), `${PortalTelemetryScreen.PaymentUnsuccessful}.onClick.onClick_1`, _ => { onRetry?.(); window.location.assign(safeRetryUrl); })}>
                    Try again
                </Button>}
            </Grid>
        </>
    )
}
